angular.module('lf.common')

.factory('vindiciaService', function ($http, $rootScope, preloadData) {
  
	/*
	 * finalizeWebSessionForCreditcard is a private function that completes the handshake 
	 * with vindicia for "Add New Creditcard or "Edit Creditcard" operations 
	 */
	function finalizeWebSessionForCreditcard(vinWebSessionId) {
    	return $http({
	        method: 'POST',
	        url: lf.data.xhr.shopAction,
	        params: {
	          // all ATG fields here + product specific
	          session_id: vinWebSessionId,
	          isCheckoutFlow: preloadData.checkoutFlow,
	      	  getData: 'finalizeCreditcardAjaxResponse',
	          updateData: 'true',
	          action: 'finalizeWebSessionForCreditcardAjax',
	          amplifiHandler: '/atg/commerce/order/purchase/PaymentGroupFormHandler'
	        },
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      })
    }

	/*
	 * postToVindicia is a private function that posts the "Add New Creditcard or "Edit Creditcard"
	 * data to Vindicia  
	 */
    function postToVindicia(params) {
    	var paramsObj = {};
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.vinAjax] = 1;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.vinWebSessionMethod] = params.vinWebSessionMethod;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.paymentMethodType] = params.paymentMethodType;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.merchantAccountId] = params.merchantAccountId;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.webSessionId] = params.webSessionId;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.paymentMethodId] = params.paymentMethodId;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.paymentCurrencyCode] = params.paymentCurrencyCode;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.accountHolderName] = params.accountHolderName;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.creditCardNumber] = params.creditCardNumber;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.creditCardExpirationMonth] = params.creditCardExpirationMonth;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.creditCardExpirationYear] = params.creditCardExpirationYear;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.nameValueCvn] = params.nameValueCvn;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingAddress1] = params.billingAddress1;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingAddress2] = params.billingAddress2;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingAddress3] = params.billingAddress3;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingAddressCity] = params.billingAddressCity;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingAddressState] = params.billingAddressState;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingAddressPostalCode] = params.billingAddressPostalCode;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingAddressCountry] = params.billingAddressCountry;
    	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.billingPhone] = params.billingPhone;
    	
    	// Flag: Save This Creditcard?
    	var saveCreditCardInfo = false;
    	if(typeof params.saveCreditCardInfo != 'undefined' && params.saveCreditCardInfo) {
    		saveCreditCardInfo = true;
    		paramsObj["saveCreditCardInfo"] = "on";
        }else if(!preloadData.checkoutFlow){
        	saveCreditCardInfo = true;
        	paramsObj["saveCreditCardInfo"] = "on";
        }
    	
    	// Flag: Make this the "Default" creditcard?
    	var defaultCreditCard = "NO";
  	  	if (params.setAsDefaultCreditCard && saveCreditCardInfo) {
  	  		defaultCreditCard = "YES";
  	  	}
  	  	paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.defaultCreditCard] = defaultCreditCard;
  	
    	if(typeof params.editCreditCardVID != 'undefined' && params.editCreditCardVID != "") {
    		// Update Creditcard request
    		paramsObj[lf.data.creditCardFormData.vindiciaFormParameterNames.editCreditCard] = params.editCreditCardVID;
        	paramsObj["originalMerchantPaymentMethodVID"] = params.editCreditCardVID;
    	}
    	
    	// Step 2: POST the new credit card form to vindicia
    	return $http({
          method: 'POST',
          url: lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.vindiciaUrl,
          params: paramsObj,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
    }
    
  return {
	  
	/*
	 * initializeWebSession:
	 * Thia is vindicia service function that initiates the handshake 
	 * with vindicia for "Add New Creditcard or "Edit Creditcard" operations 
	 */
	initializeWebSession: function () {
		return $http({
	        method: 'POST',
	        url: lf.data.xhr.shopAction,
	        params: {
	          getData: 'initializeWebSessionAjaxResponse',
	          updateData: 'true',
	          action: 'initializeWebSession',
	          amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
	        },
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      })
	},
    
	/*
	 * addOrEditCreditCard is a vindicia service function that performs following
	 * end-to-end operations for "Add New Creditcard or "Edit Creditcard" in following order
	 * 1. initializeWebSession
	 * 2. postToVindicia
	 * 3. finalizeWebSessionForCreditcard
	 */
    addOrEditCreditCard: function (params, successCallback, errorCallback) {
    	/* 
			Step 1: Make initialize call to Vindicia via ATG to get 'vin_WebSession_VID'
    	 	This is currently done in the backend ATG Code. Ideally, we should do it here, when the user is actually 
    	 	submitting the creditcard (however, doing it here will add-up to the response time) 
    	   	Step 2: upon success of Step1: POST the new credit card form to vindicia
    	   	Step 3: upon success of Step2: Make finalize call to Vindicia via ATG
    	   	Step 4: upon success of Step3: Add Creditcard operation was successful. Take the user to successUrl.
        */
    	
    	/* Step 2: POST the new credit card form to vindicia */
    	postToVindicia(params)
          .success(function (postToVindiciaResponse, status, headers, config) {
        	  if(status == 200) {
        		  console.log('POST to vindicia was success');
        		  
            	  /* Step 3: Make finalize call to Vindicia via ATG */
        		  finalizeWebSessionForCreditcard(params.webSessionId)
            	        .success(function (finalizeWebSessionResponse) {
            	        	if(finalizeWebSessionResponse.data.success) {
            	        		console.log('Vindicia finalize was done successfully. taking the user to success page.');
            	        		successCallback(finalizeWebSessionResponse);
            	        	} else {
            	        		console.log('Error occured during vindicia finalize call.');
      		            	  	errorCallback(finalizeWebSessionResponse);
            	        	}
            	        	
            	        })
            	        .error(function (finalizeWebSessionResponse) {
    		            	console.log('Error occured during vindicia finalize call.');
    		            	errorCallback(finalizeWebSessionResponse);
    		            });
        	  } else {
        		  console.log('did not get 200 response for the POST to vindicia.');
            	  errorCallback(postToVindiciaResponse);
        	  }
          })
         .error(function (postToVindiciaResponse) {
        	 console.log('Error occured during POST call to vindicia.');
        	 errorCallback(postToVindiciaResponse);
          });
    }
  };
});
